import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { X, Menu } from 'lucide-react';
import { Drawer, DrawerContent, DrawerTrigger } from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';
export default function MobileMenu() {
  const [open, setOpen] = useState(false);
  const [openSection, setOpenSection] = useState<string | null>(null);
  const toggleSection = (section: string) => {
    setOpenSection(openSection === section ? null : section);
  };
  return <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>
        <Button variant="ghost" size="icon" className="text-white">
          <Menu className="h-6 w-6" />
          <span className="sr-only">Menu</span>
        </Button>
      </DrawerTrigger>
      <DrawerContent className="bg-[#0a0a0a] border-t border-white/10 focus:outline-none">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-2">
              
              <h2 className="text-xl font-bold text-white">Menu</h2>
            </div>
            <Button variant="ghost" size="icon" onClick={() => setOpen(false)} className="text-white">
              <X className="h-6 w-6" />
              <span className="sr-only">Close</span>
            </Button>
          </div>

          <div className="space-y-4">
            {/* About Section */}
            <Collapsible className="w-full" open={openSection === 'about'} onOpenChange={() => toggleSection('about')}>
              <CollapsibleTrigger className="flex w-full items-center justify-between py-4 text-left text-gray-200 hover:text-white transition-colors">
                <span className="text-lg font-medium">About</span>
                <ChevronDown className={cn("h-5 w-5 transition-transform", openSection === 'about' ? "transform rotate-180" : "")} />
              </CollapsibleTrigger>
              <CollapsibleContent className="space-y-3 pl-4 pt-2">
                <MobileMenuLink to="/about" onClick={() => setOpen(false)}>
                  Who is Aram AI?
                </MobileMenuLink>
                <MobileMenuLink to="/biography" onClick={() => setOpen(false)}>
                  Biography
                </MobileMenuLink>
              </CollapsibleContent>
            </Collapsible>

            {/* Products Section */}
            <Collapsible className="w-full" open={openSection === 'products'} onOpenChange={() => toggleSection('products')}>
              <CollapsibleTrigger className="flex w-full items-center justify-between py-4 text-left text-gray-200 hover:text-white transition-colors">
                <span className="text-lg font-medium">Products/Services</span>
                <ChevronDown className={cn("h-5 w-5 transition-transform", openSection === 'products' ? "transform rotate-180" : "")} />
              </CollapsibleTrigger>
              <CollapsibleContent className="space-y-3 pl-4 pt-2">
                <MobileMenuLink to="/products/prompt-manager" onClick={() => setOpen(false)}>
                  Prompt Manager
                </MobileMenuLink>
                <MobileMenuLink to="/products/ai-automation" onClick={() => setOpen(false)}>
                  AI Automation
                </MobileMenuLink>
                <MobileMenuLink to="/products/vasilenko-ai" onClick={() => setOpen(false)}>
                  Vasilenko AI
                </MobileMenuLink>
              </CollapsibleContent>
            </Collapsible>

            {/* Resources Section */}
            <Collapsible className="w-full" open={openSection === 'resources'} onOpenChange={() => toggleSection('resources')}>
              <CollapsibleTrigger className="flex w-full items-center justify-between py-4 text-left text-gray-200 hover:text-white transition-colors">
                <span className="text-lg font-medium">Resources</span>
                <ChevronDown className={cn("h-5 w-5 transition-transform", openSection === 'resources' ? "transform rotate-180" : "")} />
              </CollapsibleTrigger>
              <CollapsibleContent className="space-y-3 pl-4 pt-2">
                {/* <MobileMenuLink to="/vibe-course" onClick={() => setOpen(false)}>
                  ⚡️ Vibe Coding Course
                </MobileMenuLink> */}
                <MobileMenuExternalLink href="https://t.me/haieren" onClick={() => setOpen(false)}>
                  AI Automated Newsletter
                </MobileMenuExternalLink>
                <MobileMenuExternalLink href="https://www.youtube.com/@iamaram_ai" onClick={() => setOpen(false)}>
                  YouTube
                </MobileMenuExternalLink>
                <MobileMenuExternalLink href="https://www.instagram.com/iamaram.ai/" onClick={() => setOpen(false)}>
                  Instagram
                </MobileMenuExternalLink>
                <MobileMenuExternalLink href="https://www.linkedin.com/in/aramai" onClick={() => setOpen(false)}>
                  LinkedIn
                </MobileMenuExternalLink>
              </CollapsibleContent>
            </Collapsible>

            {/* Past Projects Section */}
            <Collapsible className="w-full" open={openSection === 'projects'} onOpenChange={() => toggleSection('projects')}>
              <CollapsibleTrigger className="flex w-full items-center justify-between py-4 text-left text-gray-200 hover:text-white transition-colors">
                <span className="text-lg font-medium">Past Projects</span>
                <ChevronDown className={cn("h-5 w-5 transition-transform", openSection === 'projects' ? "transform rotate-180" : "")} />
              </CollapsibleTrigger>
              <CollapsibleContent className="space-y-3 pl-4 pt-2">
                <MobileMenuLink to="/projects/amazon" onClick={() => setOpen(false)}>
                  Amazon FBA/Fulfilled by us
                </MobileMenuLink>
                <MobileMenuLink to="/projects/upwork" onClick={() => setOpen(false)}>
                  Upwork
                </MobileMenuLink>
              </CollapsibleContent>
            </Collapsible>

            {/* Donate Button */}
            {/* <div className="pt-6">
              <Button asChild variant="outline" className="w-full gradient-border bg-black/60 border border-[#9b87f5] hover:bg-black/80 text-white py-6">
                <Link to="/donate" className="flex items-center justify-center gap-2 text-lg" onClick={() => setOpen(false)}>
                  <div className="w-5 h-5 flex items-center justify-center animate-heartbeat">
                    <img src="/lovable-uploads/db0a8c1d-0735-4000-94e6-b2c38cd9e104.png" alt="Pixelated heart" className="w-full h-full object-contain" />
                  </div>
                  Donate
                </Link>
              </Button>
            </div> */}
          </div>
        </div>
      </DrawerContent>
    </Drawer>;
}

// Helper components for mobile menu links
function MobileMenuLink({
  children,
  to,
  onClick
}: {
  children: React.ReactNode;
  to: string;
  onClick?: () => void;
}) {
  return <Link to={to} className="block py-3 text-base text-gray-300 hover:text-white transition-colors" onClick={onClick}>
      {children}
    </Link>;
}
function MobileMenuExternalLink({
  children,
  href,
  onClick
}: {
  children: React.ReactNode;
  href: string;
  onClick?: () => void;
}) {
  return <a href={href} target="_blank" rel="noreferrer" className="block py-3 text-base text-gray-300 hover:text-white transition-colors" onClick={onClick}>
      {children}
    </a>;
}